<template>
    <div class="btn-toolbar" role="toolbar">

        <div class="btn-group offset-right">

            <label class="btn btn-primary mb-0" v-bind:class="{ disabled: !writeAccess }">
                <i class="fa fa-upload"></i>
                <span class="">{{ t.__('Prześlij plik') }}</span>
                <input style="display: none;"
                       name="files[]"
                       type="file"
                       multiple
                       v-bind:accept="this.mimeTypes"
                       :disabled="!writeAccess"
                       @change="uploadFile($event.target.name, $event.target.files)">
            </label>

            <button
                    class="btn btn-primary"
                    type="button"
                    :disabled="!writeAccess"
                    @click="openModalCreateFolder()">
                <i class="fa fa-plus"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Utwórz katalog') }}</span>
            </button>
        </div>

        <div class="btn-group offset-right">
            <button
                    class="btn btn-light"
                    type="button"
                    @click="refresh()">
                <i class="fa fa-refresh"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Odśwież') }}</span>
            </button>
        </div>

        <div class="btn-group offset-right">
            <button
                    :disabled="!isFile(currentFile) || !writeAccess"
                    class="btn btn-light"
                    type="button"
                    @click="openModalMoveItem()">
                <i class="fa  fa-arrow-right"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Prześlij plik') }}</span>
            </button>

            <button
                    :disabled="!isFile(currentFile) || !writeAccess"
                    class="btn btn-light"
                    type="button"
                    @click="openModalDeleteItem()">
                <i class="fa fa-trash"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Usuń') }}</span>
            </button>

            <button
                    :disabled="!isFile(currentFile) || !writeAccess"
                    class="btn btn-light"
                    type="button"
                    @click="openModalRenameItem()">
                <i class="fa fa-pencil"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Zmień nazwę') }}</span>
            </button>

            <a :disabled="Object.keys(currentFile).length && isFolder(currentFile)"
               class="btn btn-light"
               :href="currentFile.webPath"
               target="_blank">
                <i class="fa fa-download"></i>
                <span class="d-none d-sm-none d-md-none d-lg-inline-block">{{ t.__('Pobierz') }}</span>
            </a>

        </div>

    </div>
</template>

<script>
    import fileManagerMixin from "./../../mixins/file-manager-mixin";

    export default {
        mixins: [fileManagerMixin],

        props: {
            currentFile: {
                default: function () {
                    return {};
                },
                type: [Object, Boolean]
            },
            currentPath: {
                default: "",
                type: String
            },
            mimeTypes: {
                default: "",
                type: String
            },
            writeAccess: {
                default: true,
                type: Boolean
            }
        },

        methods: {
            refresh() {
                this.$emit("reload-folder");
            },

            uploadFile(fileName, fileList) {
                this.$emit("upload-file", {
                    name: fileName,
                    files: fileList,
                    mimeTypes: this.mimeTypes
                });
            },

            openModalCreateFolder() {
                this.$emit("open-modal-create-folder");
            },

            openModalMoveItem() {
                this.$emit("open-modal-move-item");
            },

            openModalDeleteItem() {
                this.$emit("open-modal-delete-item");

            },

            openModalRenameItem() {
                this.$emit("open-modal-rename-item");

            }
        }
    };
</script>
